<template>
  <div class="page-outbox">
  	<!--搜索框-->
  	<div class="search-group-wapper">
  		<search-block @searchSub='searchSub' ref="searchBlock"></search-block>
  	</div>
    <!--列表-->
    <div class="list-wapper">
    	<scroll @scroll="scroll"
	            @scrollToEnd="scrollToEnd"
	            @scrollToTop="scrollToTop"
	            :listen-scroll="listenScroll"
	            :probe-type="probeType"
	            :data="data"
	            :pullup="true"
	            class="listview"
	            ref="listview">
	      <ul class="query-list">
	        <div class="pullDown">{{pullDownMsg}}</div>
          <p class="empty-list" v-if="data.length<1">暂无数据</p>
	        <li class="list-item" v-for="(item,index) in data" ref="listGroup" @click="toDetail(item)">
	        	<goods-item :goodsData="item"></goods-item>

	        </li>
	        <div class="pullUp">{{pullUpMsg}}</div>
	      </ul>
	    </scroll>
    </div>
  </div>
</template>

<script>
  import Scroll from 'basic/scroll/scroll'
  import GoodsItem from 'basic/goodsItem/goodsItem'
  import SearchBlock from 'basic/searchBlock/searchBlock'

	export default {
    name: 'searchIndex',
    data () {
      return {
      	keyWord:'',
      	curPage: 1,
      	pageSize:10,
        data: [],
        pullDownMsg: "下拉刷新",
        pullUpMsg: "上拉加载",
        maxY: 0,
        hasMore:true,
        listenScroll:true,
        probeType:3
      }
    },
    mounted(){
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}
			this.keyWord=this.$route.params.keyword;
			this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
			this.probeType = 3;
      this.listenScroll = true;
      this.touch = {};

      this._getData(true);
    },
    methods:{
    	refresh() {
        this.$refs.listview.refresh()
      },
      scroll(scrollPos,maxY) {
        if (scrollPos.y > 30) {
          this.pullDownMsg='释放刷新';
        }
        if(scrollPos.y<= (maxY - 40)&&this.hasMore){
      		this.pullUpMsg='释放加载更多';
        }
      },
      scrollToEnd(){
      	if(this.hasMore){
      		this._getData();
      	}

      },
      scrollToTop(){
      	this.hasMore=true;
      	this.curPage=1;
        this._getData(true);
      },
      toDetail(item){
      	this.$router.push({path:'/GoodsDetail/'+item.id})
      },
      searchSub(keyWord){
      	this.keyWord=keyWord;
      	this.hasMore=true;
      	this.curPage=1;
        this._getData(true);
        this.$refs.listview.scrollTo(0,0)
      },
      _getData(clear){
      	if(!this.keyWord){
      		this.$toast('请输入关键字');
      		return;
      	}
      	this.$cHttp.post('products/search',{
	      	partner:this.$systemConfig.partner,
	      	apikey:this.$systemConfig.apikey,
	      	keywords:this.keyWord?this.keyWord:'',
	      	page_pernum:this.pageSize,
	      	current_page:this.curPage
      	}).then((res)=>{
      			console.log(res)
      			if(res.status&&res.status==1){
			      	if(clear){
			      		this.data=res.data.rows;
			      	}else{
			      		this.data=this.data.concat(res.data.rows);
			      	}
			      	if(this.curPage+1>res.data.total_page){
			      		this.hasMore=false;
			      		this.pullUpMsg='没有更多数据了';
			      	}else{
			      		this.curPage++;
			      	}
			      	if(res.data.rows.length<1){
			      		this.$toast('暂无数据');
			      	}
      			}else{
      				this.$toast('暂无数据')
      			}
      	}).catch((msg)=>{
      		this.$toast(msg);
      	})
      }
    },
    components:{
        Scroll,GoodsItem,SearchBlock
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.search-group-wapper{
		position: absolute;
    top:0;
    left:0;
    width: 100%;
	}
	.listview{
	  position: absolute;
	  width: 100%;
	  top:.61rem;;
		left:0;
		bottom:0;
	  overflow: hidden;
	}
	.list-wapper{
	  .query-list{
	    min-height: 100.3%;
	    .pullDown{
	      position: absolute;
	      top: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .pullUp{
	      position: absolute;
	      bottom: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .list-item{
		     border-bottom: 1px solid #eee;
	    }
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/goodsList/goodsList.vue